import { toast } from 'react-toastify';

import { takeLatest, call, put, all } from 'redux-saga/effects';

import api from '~/services/api';
import history from '~/services/history';

import { requestTranslate } from '../language/actions';
import { signInSuccess, signFailure } from './actions';

export function* signIn({ payload }) {
  try {
    const { usuario, senha } = payload;
    let { subdominio } = payload;

    if (process.env.NODE_ENV === 'development') {
      subdominio = 'sgta-dev';
      //subdominio = 'Abastek';
    }

    const { data } = yield call(api.post, 'logins', {
      subdominio,
      usuario,
      senha,
    });

    /*
       / Set informacoes para as variaveis globais e barra de status
         Application.application.gloUsuarioLogin=arrDadosRetorno.getItemAt(0).usua_login;
         Application.application.gloUsuarioTipo=arrDadosRetorno.getItemAt(0).perf_tipo;
         Application.application.gloUsuarioUnidadeCodigo=arrDadosRetorno.getItemAt(0).unid_codigo;
         Application.application.gloUsuarioOrgaCodigo=arrDadosRetorno.getItemAt(0).orga_codigo;
         Application.application.gloUsuarioPostoCodigo=arrDadosRetorno.getItemAt(0).poco_codigo;
         Application.application.gloUsuarioEmpresa="XPTO";
         Application.application.gloUsuarioEmpresaDescricao="XPTO";
         Application.application.gloPerfilID=arrDadosRetorno.getItemAt(0).perf_codigo;
         Application.application.appNomeUsuario.text=arrDadosRetorno.getItemAt(0).usua_nome;
         Application.application.appPerfilUsuario.text=arrDadosRetorno.getItemAt(0).perf_descricao;
         Application.application.gloUsuarioOrgaNome=arrDadosRetorno.getItemAt(0).orga_nome;
         Application.application.gloUsua_Aprova_Pre_Faturamento=arrDadosRetorno.getItemAt(0).usua_aprova_pre_faturamento;
         Application.application.gloFadi_Codigo=arrDadosRetorno.getItemAt(0).fadi_codigo;
         Application.application.gloPoco_recebimento_fracionado = arrDadosRetorno.getItemAt(0).poco_recebimento_fracionado;
    */

    /*
      glousuariologin: data.usua_login,
      glousuariotipo: data.perf_tipo,
      glousuariounidadecodigo: data.unid_codigo,
      glousuarioorgacodigo: data.orga_codigo,
      glousuariopostocodigo: data.poco_codigo,
      glousuarioempresa="XPTO",
      glousuarioempresadescricao="XPTO",
      gloperfilid: data.perf_codigo,
      appnomeusuario: data.usua_nome,
      appperfilusuario: data.perf_descricao,
      glousuarioorganome: data.orga_nome,
      glousua_aprova_pre_faturamento: data.usua_aprova_pre_faturamento,
      glofadi_codigo: data.fadi_codigo,
      glopoco_recebimento_fracionado: data.poco_recebimento_fracionado,
*/

    const user = {
      id: data.usua_login,
      name: data.nomeusuario,
      client: data.idcliente,
      username: data.codigousuario,
      perfcodigo: data.perf_codigo,

      perf_tipo: data.usuarioacesso.perf_tipo,
      url_help: data.usuarioacesso.url_help,
      glousuariologin: data.usuarioacesso.usua_login,
      glousuariotipo: data.usuarioacesso.perf_tipo,
      glousuariounidadecodigo: data.usuarioacesso.unid_codigo,
      glousuarioorgacodigo: data.usuarioacesso.orga_codigo,
      glousuariopostocodigo: data.usuarioacesso.poco_codigo,
      glousuarioempresa: 'XPTO',
      glousuarioempresadescricao: 'XPTO',
      gloperfilid: data.usuarioacesso.perf_codigo,
      appnomeusuario: data.usuarioacesso.usua_nome,
      appperfilusuario: data.usuarioacesso.perf_descricao,
      glousuarioorganome: data.usuarioacesso.orga_nome,
      glousua_aprova_pre_faturamento:
        data.usuarioacesso.usua_aprova_pre_faturamento,
      glofadi_codigo: data.usuarioacesso.fadi_codigo,
      glopoco_recebimento_fracionado:
        data.usuarioacesso.poco_recebimento_fracionado,
    };

    api.defaults.headers.token = data.token;

    yield put(
      signInSuccess(data.token, user, data.usuarioacesso, data.modulos, 'pt-BR')
    );
    yield put(requestTranslate());

    history.push('/dashboard');
  } catch (erros) {
    erros.map((error) => toast.error(error));
    yield put(signFailure());
  }
}

export function setToken({ payload }) {
  if (!payload) return;

  const { token } = payload.auth;

  if (token) {
    api.defaults.headers.token = token;
  }
}

export function signOut() {
  history.push('/');
}

export default all([
  takeLatest('persist/REHYDRATE', setToken),
  takeLatest('@auth/SIGN_IN_REQUEST', signIn),
  takeLatest('@auth/SIGN_OUT', signOut),
]);
